import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import VenueCard from "@/components/VenueCard";

export default function Venues() {
  const [venues, setVenues] = useState([]);

  useEffect(() => {
    api.get("/venues").then((r) => setVenues(r.data)).catch(() => {});
  }, []);

  const owned = venues.filter((v) => v.abe_owned);
  const partner = venues.filter((v) => !v.abe_owned);

  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 py-10">
      <span className="section-eyebrow">Experiences Across Huntsville</span>
      <h1 className="font-display text-4xl sm:text-5xl uppercase text-white mt-2 mb-8 leading-none">Our Venues</h1>

      {owned.length > 0 && (
        <section className="mb-12">
          <h2 className="font-oswald text-sm font-bold tracking-widest text-[#D4AF37] uppercase mb-4">ABE Owned & Featured</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {owned.map((v) => <VenueCard key={v.id} venue={v} />)}
          </div>
        </section>
      )}

      {partner.length > 0 && (
        <section>
          <h2 className="font-oswald text-sm font-bold tracking-widest text-zinc-400 uppercase mb-4">Other Event Locations</h2>
          <p className="text-xs text-zinc-500 mb-4 max-w-lg">ABE promotes select events at these partner venues. These venues are not owned by ABE.</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {partner.map((v) => <VenueCard key={v.id} venue={v} />)}
          </div>
        </section>
      )}

      {venues.length === 0 && (
        <div className="rounded-xl border border-[#27272A] p-14 text-center">
          <p className="font-display text-2xl text-white uppercase">No Venues Yet</p>
        </div>
      )}
    </div>
  );
}
